module.exports = __webpack_public_path__ + "img/0-15.8e496404.jpg";